export const ledgerAdoptionTranslations = {
    en: {
        additionalAccounts: 'Additional opening accounts',
        addAccount: 'Add account',
        paymentEvidenceTitle: 'Original payment evidence',
        noReference: 'No source reference recorded',
        allocationCount: 'Allocations',
        unallocated: 'Unallocated',
        title: 'Start accounting with reviewed balances',
        intro: 'Select the cutover date. The review preserves existing invoices and payments. Activation records only evidenced opening balances and outstanding items, without inventing historical payments.',
        invoices: 'Outstanding invoices',
        invoiceHint: 'Check original totals, recorded paid values and actual payment evidence. If you change a balance or rate, enter the source reference.',
        noInvoices: 'No historical invoices found.',
        balances: 'Opening account balances',
        balanceHint: 'Enter signed balances in EUR: positive for debit, negative for credit. Invoice controls and remaining deferred VAT are calculated from the reviewed outstanding items. Include evidenced bank, cash, previously deducted input tax and equity balances until debit equals credit. Input tax is never posted again from supplier opening invoices.',
        account: 'Account',
        amount: 'Signed balance (EUR)',
        evidence: 'Evidence reference',
        remove: 'Remove',
        addBalance: 'Add opening balance',
        preview: 'Calculate frozen review',
        calculating: 'Calculating review…',
        emptyStart: 'Start an empty company',
        review: 'Review before activation',
        paymentCount: 'Existing payments: {{customerCount}} customer / {{vendorCount}} supplier. Their original records remain retained.',
        debit: 'Debit',
        credit: 'Credit',
        difference: 'Difference',
        recalculate: 'Inputs changed. Calculate a new review before activation.',
        confirm: 'I have checked the sources, opening balances and outstanding items and explicitly approve activation.',
        apply: 'Activate reviewed accounting',
        applying: 'Activating…',
        applied: 'Accounting activated with reviewed opening balances.',
        CUSTOMER: 'Customer',
        VENDOR: 'Supplier',
        original: 'Original gross',
        paid: 'Recorded paid',
        proven: 'Payment evidence',
        open: 'Outstanding at cutover',
        rate: 'Opening exchange rate',
        findings: {
            sourceBalanceMismatch: 'The reviewed outstanding balance differs from the original invoice less its recorded payments and discounts. Reconcile the source; a review cannot invent a payment or settlement.',
            accountExists: 'An account number already exists in the selected chart.',
            futureStart: 'The start date cannot be in the future.',
            existingLedger: 'Accounting already contains entries or configuration.',
            sourceAfterStart: 'A source is on or after the start date. Choose a later cutover date.',
            paymentEvidence: 'Payment evidence has an ambiguous date, reversal or direction. Correct the source before continuing.',
            unprovenPaid: 'The recorded paid value is not fully supported by actual payments. No historical payment will be created.',
            reviewRequired: 'Enter an explicitly reviewed outstanding balance and evidence reference.',
            invalidOpen: 'The outstanding balance must have the original sign and cannot exceed the original invoice.',
            rateEvidence: 'A valid opening exchange rate and reference are required for foreign currency.',
            reviewedBalance: 'A reviewed balance differs from the payment-based calculation.',
            unallocatedPayment: 'An unallocated historical payment requires reconciliation before adoption.',
            sourceInvalid: 'The referenced source no longer belongs to this review.',
            managedBalance: 'Receivable, payable and deferred VAT balances come from the reviewed invoice items.',
            unbalanced: 'Opening debit and credit do not balance. Add or correct evidenced opening balances.',
            taxReview: 'The invoice VAT evidence needs correction before adoption.',
        },
        errors: {
            validation: 'Check dates, amounts and evidence references. Inputs remain retained.',
            stale: 'The reviewed evidence changed. Calculate a fresh review before activation.',
        },
        deferredTax: 'Remaining deferred VAT (opening credit is negative)',
    },
    de: {
        additionalAccounts: 'Zusätzliche Eröffnungskonten',
        addAccount: 'Konto ergänzen',
        paymentEvidenceTitle: 'Ursprüngliche Zahlungsnachweise',
        noReference: 'Keine Quellenreferenz erfasst',
        allocationCount: 'Zuordnungen',
        unallocated: 'Nicht zugeordnet',
        title: 'Buchhaltung mit geprüften Beständen starten',
        intro: 'Wählen Sie den Stichtag. Die Prüfung erhält bestehende Rechnungen und Zahlungen. Die Aktivierung übernimmt ausschließlich belegte Eröffnungssalden und offene Posten, ohne historische Zahlungen zu erfinden.',
        invoices: 'Offene Rechnungen',
        invoiceHint: 'Prüfen Sie Originalbeträge, erfasste Zahlwerte und tatsächliche Zahlungsnachweise. Bei geänderten Salden oder Kursen geben Sie die Belegreferenz an.',
        noInvoices: 'Keine historischen Rechnungen gefunden.',
        balances: 'Eröffnungssalden',
        balanceHint: 'Erfassen Sie Salden in EUR: positiv für Soll, negativ für Haben. Sammelkonten und verbleibende nicht fällige Umsatzsteuer werden aus geprüften offenen Posten ermittelt. Ergänzen Sie belegte Bank-, Kassen-, bereits abgezogene Vorsteuer- und Eigenkapitalsalden, bis Soll und Haben übereinstimmen. Vorsteuer aus Lieferanten-Eröffnungsrechnungen wird nicht erneut gebucht.',
        account: 'Konto',
        amount: 'Saldo mit Vorzeichen (EUR)',
        evidence: 'Nachweisreferenz',
        remove: 'Entfernen',
        addBalance: 'Eröffnungssaldo ergänzen',
        preview: 'Festgehaltene Vorschau berechnen',
        calculating: 'Vorschau wird berechnet…',
        emptyStart: 'Leeren Mandanten starten',
        review: 'Prüfung vor Aktivierung',
        paymentCount: 'Bestehende Zahlungen: {{customerCount}} Kunden / {{vendorCount}} Lieferanten. Die Originaldatensätze bleiben erhalten.',
        debit: 'Soll',
        credit: 'Haben',
        difference: 'Differenz',
        recalculate: 'Eingaben geändert. Berechnen Sie vor der Aktivierung eine neue Vorschau.',
        confirm: 'Ich habe Quellen, Eröffnungssalden und offene Posten geprüft und stimme der Aktivierung ausdrücklich zu.',
        apply: 'Geprüfte Buchhaltung aktivieren',
        applying: 'Aktivierung läuft…',
        applied: 'Buchhaltung mit geprüften Eröffnungssalden aktiviert.',
        CUSTOMER: 'Kunde',
        VENDOR: 'Lieferant',
        original: 'Originalbrutto',
        paid: 'Erfasst bezahlt',
        proven: 'Zahlungsnachweis',
        open: 'Offen am Stichtag',
        rate: 'Eröffnungskurs',
        findings: {
            sourceBalanceMismatch: 'Der geprüfte offene Saldo weicht vom Original abzüglich erfasster Zahlungen und Skonti ab. Stimmen Sie die Quelle ab; eine Prüfung darf keine Zahlung oder Verrechnung erfinden.',
            accountExists: 'Eine Kontonummer ist im gewählten Kontenplan bereits vorhanden.',
            futureStart: 'Das Startdatum darf nicht in der Zukunft liegen.',
            existingLedger: 'Die Buchhaltung enthält bereits Buchungen oder Konfiguration.',
            sourceAfterStart: 'Eine Quelle liegt am oder nach dem Startdatum. Wählen Sie einen späteren Stichtag.',
            paymentEvidence: 'Zahlungsdatum, Storno oder Richtung sind nicht eindeutig belegt. Korrigieren Sie die Quelle vor der Übernahme.',
            unprovenPaid: 'Der erfasste Zahlwert ist nicht vollständig durch tatsächliche Zahlungen belegt. Es wird keine historische Zahlung angelegt.',
            reviewRequired: 'Erfassen Sie einen ausdrücklich geprüften offenen Saldo mit Nachweisreferenz.',
            invalidOpen: 'Der offene Saldo muss das ursprüngliche Vorzeichen behalten und darf die Rechnung nicht übersteigen.',
            rateEvidence: 'Für Fremdwährung sind ein gültiger Eröffnungskurs und Nachweis erforderlich.',
            reviewedBalance: 'Ein geprüfter Saldo weicht von der Berechnung aus Zahlungen ab.',
            unallocatedPayment: 'Eine nicht zugeordnete historische Zahlung muss vor der Übernahme abgestimmt werden.',
            sourceInvalid: 'Die referenzierte Quelle gehört nicht mehr zu dieser Prüfung.',
            managedBalance: 'Forderungen, Verbindlichkeiten und nicht fällige Umsatzsteuer entstehen aus geprüften Rechnungsposten.',
            unbalanced: 'Eröffnungssoll und -haben sind nicht ausgeglichen. Ergänzen oder korrigieren Sie belegte Eröffnungssalden.',
            taxReview: 'Die Umsatzsteuernachweise der Rechnung müssen vor der Übernahme korrigiert werden.',
        },
        errors: {
            validation: 'Prüfen Sie Daten, Beträge und Nachweisreferenzen. Ihre Eingaben bleiben erhalten.',
            stale: 'Die geprüften Quellen haben sich geändert. Berechnen Sie vor der Aktivierung eine neue Vorschau.',
        },
        deferredTax: 'Verbleibende nicht fällige Umsatzsteuer (Eröffnungshaben negativ)',
    },
    fr: {
        additionalAccounts: 'Comptes d’ouverture supplémentaires',
        addAccount: 'Ajouter un compte',
        paymentEvidenceTitle: 'Justificatifs de paiement originaux',
        noReference: 'Aucune référence de source enregistrée',
        allocationCount: 'Affectations',
        unallocated: 'Non affecté',
        title: 'Démarrer la comptabilité avec des soldes vérifiés',
        intro: 'Choisissez la date de reprise. Le contrôle conserve les factures et paiements existants. L’activation reprend uniquement les soldes et postes ouverts justifiés, sans inventer de paiements historiques.',
        invoices: 'Factures ouvertes',
        invoiceHint: 'Vérifiez les montants originaux, les montants déclarés payés et les preuves réelles. Toute modification de solde ou de taux exige une référence justificative.',
        noInvoices: 'Aucune facture historique trouvée.',
        balances: 'Soldes d’ouverture',
        balanceHint: 'Saisissez les soldes en EUR : positifs au débit, négatifs au crédit. Les comptes collectifs et la TVA différée proviennent des postes vérifiés. Ajoutez les soldes justifiés de banque, caisse, TVA déjà déduite et capitaux propres jusqu’à équilibrage. La reprise fournisseur ne déduit jamais la TVA une seconde fois.',
        account: 'Compte',
        amount: 'Solde signé (EUR)',
        evidence: 'Référence justificative',
        remove: 'Supprimer',
        addBalance: 'Ajouter un solde d’ouverture',
        preview: 'Calculer l’aperçu figé',
        calculating: 'Calcul en cours…',
        emptyStart: 'Démarrer une société vide',
        review: 'Contrôle avant activation',
        paymentCount: 'Paiements existants : {{customerCount}} clients / {{vendorCount}} fournisseurs. Les originaux sont conservés.',
        debit: 'Débit',
        credit: 'Crédit',
        difference: 'Écart',
        recalculate: 'Les données ont changé. Recalculez l’aperçu avant l’activation.',
        confirm: 'J’ai vérifié les sources, les soldes et les postes ouverts et j’approuve explicitement l’activation.',
        apply: 'Activer la comptabilité vérifiée',
        applying: 'Activation en cours…',
        applied: 'Comptabilité activée avec les soldes vérifiés.',
        CUSTOMER: 'Client',
        VENDOR: 'Fournisseur',
        original: 'Brut original',
        paid: 'Déclaré payé',
        proven: 'Preuve de paiement',
        open: 'Ouvert à la reprise',
        rate: 'Taux d’ouverture',
        findings: {
            sourceBalanceMismatch: 'Le solde vérifié diffère de la facture moins les paiements et escomptes enregistrés. Rapprochez la source ; le contrôle ne peut pas inventer de paiement ni de compensation.',
            accountExists: 'Un numéro de compte existe déjà dans le plan sélectionné.',
            futureStart: 'La date de début ne peut pas être future.',
            existingLedger: 'La comptabilité contient déjà des écritures ou une configuration.',
            sourceAfterStart: 'Une source est datée du jour de reprise ou après. Choisissez une reprise ultérieure.',
            paymentEvidence: 'La date, l’annulation ou le sens du paiement sont ambigus. Corrigez la source.',
            unprovenPaid: 'Le montant déclaré payé n’est pas entièrement justifié. Aucun paiement historique ne sera créé.',
            reviewRequired: 'Saisissez un solde ouvert explicitement vérifié et sa référence.',
            invalidOpen: 'Le solde doit conserver le signe d’origine et ne peut pas dépasser la facture.',
            rateEvidence: 'Une devise étrangère exige un taux d’ouverture valide et sa justification.',
            reviewedBalance: 'Un solde vérifié diffère du calcul fondé sur les paiements.',
            unallocatedPayment: 'Un paiement historique non affecté doit être rapproché avant la reprise.',
            sourceInvalid: 'La source référencée ne fait plus partie de ce contrôle.',
            managedBalance: 'Les comptes clients, fournisseurs et la TVA différée proviennent des postes vérifiés.',
            unbalanced: 'Le débit et le crédit d’ouverture ne sont pas équilibrés. Complétez ou corrigez les soldes justifiés.',
            taxReview: 'Les justificatifs de TVA doivent être corrigés avant la reprise.',
        },
        errors: {
            validation: 'Vérifiez les dates, montants et références. Vos saisies sont conservées.',
            stale: 'Les justificatifs ont changé. Recalculez l’aperçu avant activation.',
        },
        deferredTax: 'TVA différée restante (crédit d’ouverture négatif)',
    },
    es: {
        additionalAccounts: 'Cuentas de apertura adicionales',
        addAccount: 'Añadir cuenta',
        paymentEvidenceTitle: 'Justificantes de pago originales',
        noReference: 'No se registró referencia de origen',
        allocationCount: 'Asignaciones',
        unallocated: 'Sin asignar',
        title: 'Iniciar contabilidad con saldos revisados',
        intro: 'Elija la fecha de inicio. La revisión conserva las facturas y los pagos existentes. La activación registra solo saldos y partidas abiertas acreditados, sin inventar pagos históricos.',
        invoices: 'Facturas pendientes',
        invoiceHint: 'Revise los importes originales, los valores pagados registrados y los justificantes reales. Si cambia un saldo o tipo de cambio, indique la referencia.',
        noInvoices: 'No se encontraron facturas históricas.',
        balances: 'Saldos de apertura',
        balanceHint: 'Introduzca saldos en EUR: positivos al debe, negativos al haber. Las cuentas de control y el IVA diferido se calculan desde las partidas revisadas. Añada bancos, caja, IVA soportado ya deducido y patrimonio acreditados hasta cuadrar. La apertura de facturas de proveedores nunca vuelve a deducir el IVA.',
        account: 'Cuenta',
        amount: 'Saldo con signo (EUR)',
        evidence: 'Referencia del justificante',
        remove: 'Eliminar',
        addBalance: 'Añadir saldo de apertura',
        preview: 'Calcular vista previa fija',
        calculating: 'Calculando…',
        emptyStart: 'Iniciar una empresa vacía',
        review: 'Revisión antes de activar',
        paymentCount: 'Pagos existentes: {{customerCount}} clientes / {{vendorCount}} proveedores. Se conservan los originales.',
        debit: 'Debe',
        credit: 'Haber',
        difference: 'Diferencia',
        recalculate: 'Los datos han cambiado. Calcule otra vista previa antes de activar.',
        confirm: 'He revisado las fuentes, los saldos y las partidas pendientes y apruebo expresamente la activación.',
        apply: 'Activar contabilidad revisada',
        applying: 'Activando…',
        applied: 'Contabilidad activada con saldos revisados.',
        CUSTOMER: 'Cliente',
        VENDOR: 'Proveedor',
        original: 'Bruto original',
        paid: 'Pago registrado',
        proven: 'Justificante de pago',
        open: 'Pendiente al inicio',
        rate: 'Tipo de cambio inicial',
        findings: {
            sourceBalanceMismatch: 'El saldo revisado difiere de la factura menos los pagos y descuentos registrados. Concilie la fuente; una revisión no puede inventar pagos ni compensaciones.',
            accountExists: 'Un número de cuenta ya existe en el plan seleccionado.',
            futureStart: 'La fecha de inicio no puede ser futura.',
            existingLedger: 'La contabilidad ya contiene asientos o configuración.',
            sourceAfterStart: 'Una fuente tiene fecha igual o posterior al inicio. Elija una fecha de corte posterior.',
            paymentEvidence: 'La fecha, anulación o dirección del pago es ambigua. Corrija la fuente.',
            unprovenPaid: 'El importe pagado registrado no está acreditado por completo. No se creará un pago histórico.',
            reviewRequired: 'Introduzca un saldo pendiente revisado expresamente y su justificante.',
            invalidOpen: 'El saldo debe conservar el signo original y no superar la factura.',
            rateEvidence: 'La divisa extranjera exige un tipo de apertura válido y un justificante.',
            reviewedBalance: 'Un saldo revisado difiere del cálculo basado en pagos.',
            unallocatedPayment: 'Un pago histórico sin asignar requiere conciliación antes de la adopción.',
            sourceInvalid: 'La fuente referida ya no pertenece a esta revisión.',
            managedBalance: 'Los saldos de clientes, proveedores e IVA diferido proceden de las facturas revisadas.',
            unbalanced: 'El debe y el haber de apertura no cuadran. Añada o corrija los saldos acreditados.',
            taxReview: 'Los justificantes de IVA deben corregirse antes de la adopción.',
        },
        errors: {
            validation: 'Revise fechas, importes y referencias. Se conservan los datos.',
            stale: 'Las fuentes revisadas han cambiado. Calcule otra vista previa antes de activar.',
        },
        deferredTax: 'IVA diferido pendiente (haber de apertura negativo)',
    },
    tr: {
        additionalAccounts: 'Ek açılış hesapları',
        addAccount: 'Hesap ekle',
        paymentEvidenceTitle: 'Özgün ödeme kanıtları',
        noReference: 'Kaynak referansı kaydedilmemiş',
        allocationCount: 'Atamalar',
        unallocated: 'Atanmamış',
        title: 'Muhasebeyi incelenmiş bakiyelerle başlatın',
        intro: 'Geçiş tarihini seçin. İnceleme mevcut fatura ve ödemeleri korur. Etkinleştirme yalnızca belgelenmiş açılış bakiyelerini ve açık kalemleri kaydeder; geçmiş ödeme oluşturmaz.',
        invoices: 'Açık faturalar',
        invoiceHint: 'Özgün tutarları, kayıtlı ödenen değerleri ve gerçek ödeme kanıtlarını inceleyin. Bakiye veya kur değiştiğinde belge referansını girin.',
        noInvoices: 'Geçmiş fatura bulunamadı.',
        balances: 'Açılış hesap bakiyeleri',
        balanceHint: 'EUR bakiyelerini girin: borç için pozitif, alacak için negatif. Kontrol hesapları ve ertelenmiş KDV, incelenen açık kalemlerden hesaplanır. Borç ve alacak eşitlenene kadar belgeli banka, kasa, önceden indirilmiş KDV ve özkaynak bakiyelerini ekleyin. Tedarikçi açılış faturalarından KDV yeniden indirilmez.',
        account: 'Hesap',
        amount: 'İşaretli bakiye (EUR)',
        evidence: 'Kanıt referansı',
        remove: 'Kaldır',
        addBalance: 'Açılış bakiyesi ekle',
        preview: 'Sabit önizlemeyi hesapla',
        calculating: 'Önizleme hesaplanıyor…',
        emptyStart: 'Boş şirketi başlat',
        review: 'Etkinleştirme öncesi inceleme',
        paymentCount: 'Mevcut ödemeler: {{customerCount}} müşteri / {{vendorCount}} tedarikçi. Özgün kayıtlar korunur.',
        debit: 'Borç',
        credit: 'Alacak',
        difference: 'Fark',
        recalculate: 'Girdiler değişti. Etkinleştirmeden önce yeni bir önizleme hesaplayın.',
        confirm: 'Kaynakları, açılış bakiyelerini ve açık kalemleri inceledim ve etkinleştirmeyi açıkça onaylıyorum.',
        apply: 'İncelenmiş muhasebeyi etkinleştir',
        applying: 'Etkinleştiriliyor…',
        applied: 'Muhasebe incelenmiş açılış bakiyeleriyle etkinleştirildi.',
        CUSTOMER: 'Müşteri',
        VENDOR: 'Tedarikçi',
        original: 'Özgün brüt',
        paid: 'Kayıtlı ödenen',
        proven: 'Ödeme kanıtı',
        open: 'Geçişte açık',
        rate: 'Açılış döviz kuru',
        findings: {
            sourceBalanceMismatch: 'İncelenen açık bakiye, özgün faturadan kayıtlı ödeme ve iskontolar çıkarıldıktan sonraki tutardan farklı. Kaynağı uzlaştırın; inceleme ödeme veya mahsup uyduramaz.',
            accountExists: 'Seçilen hesap planında bir hesap numarası zaten var.',
            futureStart: 'Başlangıç tarihi gelecekte olamaz.',
            existingLedger: 'Muhasebede zaten kayıt veya yapılandırma var.',
            sourceAfterStart: 'Bir kaynağın tarihi geçiş gününde veya sonrasında. Daha sonraki bir tarih seçin.',
            paymentEvidence: 'Ödeme tarihi, ters kayıt veya yön belirsiz. Devam etmeden önce kaynağı düzeltin.',
            unprovenPaid: 'Kayıtlı ödenen tutar gerçek ödemelerle tamamen desteklenmiyor. Geçmiş ödeme oluşturulmaz.',
            reviewRequired: 'Açıkça incelenmiş açık bakiye ve kanıt referansı girin.',
            invalidOpen: 'Açık bakiye özgün işareti korumalı ve faturayı aşmamalı.',
            rateEvidence: 'Yabancı para için geçerli bir açılış kuru ve kanıt gereklidir.',
            reviewedBalance: 'İncelenen bakiye, ödemelerden hesaplanan tutardan farklı.',
            unallocatedPayment: 'Atanmamış geçmiş ödeme aktarım öncesinde mutabakat gerektirir.',
            sourceInvalid: 'Başvurulan kaynak artık bu incelemeye ait değil.',
            managedBalance: 'Alacak, borç ve ertelenmiş KDV bakiyeleri incelenen fatura kalemlerinden oluşur.',
            unbalanced: 'Açılış borç ve alacak tutarları eşit değil. Belgeli bakiyeleri ekleyin veya düzeltin.',
            taxReview: 'Aktarımdan önce fatura KDV kanıtlarını düzeltin.',
        },
        errors: {
            validation: 'Tarihleri, tutarları ve kanıt referanslarını kontrol edin. Girdileriniz korunur.',
            stale: 'İncelenen kanıtlar değişti. Etkinleştirmeden önce yeni önizleme hesaplayın.',
        },
        deferredTax: 'Kalan ertelenmiş KDV (açılış alacağı negatiftir)',
    },
};
//# sourceMappingURL=ledger-adoption.js.map